import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})

export class LoadingService {
  private loadingState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingState$: Observable<boolean> = this.loadingState.asObservable();

  private tableLoadingState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  tableLoadingState$: Observable<boolean> = this.tableLoadingState.asObservable();

  private buttonLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  buttonLoading$: Observable<boolean> = this.buttonLoading.asObservable();

  private modalLoadingState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  modalLoadingState$: Observable<boolean> = this.modalLoadingState.asObservable();

  constructor() {
  }

  setModalLoadingState(event: boolean): void {
    this.modalLoadingState.next(event);
  }

  setTableLoadingState(event: boolean): void {
    this.tableLoadingState.next(event);
  }

  setButtonLoading(event: boolean): void {
    this.buttonLoading.next(event);
  }
}
